import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageTitleService {
  private _pageTitle = signal<string>('Dashboard');

  // Removed empty constructor to fix lint error

  get pageTitle() {
    return this._pageTitle.asReadonly();
  }

  setPageTitle(title: string): void {
    this._pageTitle.set(title);
  }
}
